import {DispatchOf} from "../utils";
import {ErrorsActions} from "../reducers/toastsReducer";
import {fetchQuestions as questionsFetchQuestions} from "../../services/questionsService";
import * as types from "../../constants";
import {QuestionActions} from "../reducers/questionsReducer";

export function fetchQuestions(token: string) {
  return async (dispatch: DispatchOf<QuestionActions> & DispatchOf<ErrorsActions>) => {
    return questionsFetchQuestions(token)
      .then((response: any) => {
        dispatch({
          type: types.FETCH_QUESTIONS,
          questions: response,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}